import ErrorReportingService from "../services/ErrorReportingService";
import fetchWithUuid from "./fetchWithUuid";
import { apiStatuses, FetchApi } from "./Actions";
import checkError from "./checkError";

const fetchApi: FetchApi = (
  url,
  actionType,
  successCallback,
  failedCallback
) => dispatch => {
  const doFailed = (error: any) => {
    ErrorReportingService.report(error);

    if (failedCallback) {
      failedCallback(error);
    }

    return dispatch({
      data: {
        data: error.data,
        message: error.message,
        status: error.status
      },
      status: apiStatuses.ERROR,
      type: actionType
    });
  };

  dispatch({ type: actionType, status: apiStatuses.LOADING });

  return fetchWithUuid(url)
    .then(checkError)
    .then(res => res.json())
    .then(data => {
      dispatch({ type: actionType, status: apiStatuses.SUCCESS, data });
      if (successCallback) {
        successCallback(data);
      }
      return data;
    })
    .catch(doFailed);
};

export default fetchApi;
